import svgConnect from "../../../../assets/imgs/socials/connects/pinterest.svg";
import svgNaoConectado from "../../../../assets/imgs/socials/notConnects/pinterest.svg";

import MyImage from "../../../myImage"

const MyIconPinterest = ({sx, connect}) =><MyImage src={connect ? svgConnect : svgNaoConectado} alt={'pinterest icon'} sx={sx} />

export default MyIconPinterest;
